import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Card, ConfigProvider, message, Spin } from "antd";
import { HomeOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./privacyPolicy.css";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";

const PrivacyPolicy = () => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const fetchPrivacy = () => {
    callApi(
      "GET",
      routes.privacyPolicy,
      null,
      setLoading,
      (res) => {
        // Expecting something like { data: { content: "<p>...</p>" } }
        const html = res?.data?.content || "";
        setContent(html);
      },
      () => {
        message.error("Failed to load Privacy Policy");
      },
    );
  };

  const savePrivacy = () => {
    const body = {
      content,
    };

    callApi(
      "PATCH",
      routes.updatePrivacy,
      body,
      setSaving,
      () => {
        message.success("Privacy Policy updated successfully");
        fetchPrivacy();
      },
      () => {
        message.error("Failed to update Privacy Policy");
      },
    );
  };

  useEffect(() => {
    fetchPrivacy();
  }, []);

  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#FFA450" } }}>
      <div className="privacy-page-container">
        <Breadcrumb separator=">" className="bread-crumb">
          <div className="icon-dashboard">
            <HomeOutlined className="breadcrumb-icon" />
          </div>
          <Breadcrumb.Item>Home</Breadcrumb.Item>
          <Breadcrumb.Item>Privacy Policy</Breadcrumb.Item>
        </Breadcrumb>

        <Card
          className="privacy-card"
          title={
            <span className="privacy-title">
              <SafetyCertificateOutlined className="privacy-title-icon" />
              Privacy Policy
            </span>
          }
          extra={
            <Button
              type="primary"
              onClick={savePrivacy}
              loading={saving}
              disabled={loading}
            >
              Save Changes
            </Button>
          }
        >
          {loading ? (
            <div className="privacy-loader">
              <Spin />
            </div>
          ) : (
            <ReactQuill
              theme="snow"
              value={content}
              onChange={setContent}
              className="privacy-editor"
            />
          )}
        </Card>
      </div>
    </ConfigProvider>
  );
};

export default PrivacyPolicy;
